<script setup>
import { onMounted, reactive } from 'vue'

import useCheckbox from '@/Shared/useCheckbox.js'
import Icon from '@/Shared/Icons/Icon'

const props = defineProps({
  category: String,
  slug: String,
  dataId: Number,
})

const checkbox = reactive({
  active: false,
})

const toggleActive = () => {
  checkbox.active = !checkbox.active
}

const { updateIcon, subscribeCheckedList } = useCheckbox({ checkbox: checkbox, category: props.category, slug: props.slug })
onMounted(() => {
  updateIcon()
  subscribeCheckedList(updateIcon)
})
</script>

<template>
  <button :data-id="props.dataId" :slug="props.slug" :class="['btn-toggle-check', { active: checkbox.active }]" @click="toggleActive">
    <span><Icon type="check" /></span>
  </button>
</template>
